import type { ChatHistoryItem } from '@cast/types';

import { ChatHistoryList } from './ChatHistoryList';

import { Box, Stack, tokens } from '@cast/design-system';

type HistorySidebarProps = {
  showHistory: boolean;
  isMobile?: boolean;
  history: ChatHistoryItem[];
  currentChatId?: string;
  onSelectChat: (chatId: string) => void;
  onDeleteChat: (chatId: string) => void;
  onNewChat: () => void;
};

export const HistorySidebar = ({
  showHistory,
  isMobile,
  history,
  currentChatId,
  onSelectChat,
  onDeleteChat,
  onNewChat,
}: HistorySidebarProps) => {
  return (
    <Stack
      sx={() => ({
        ...(isMobile
          ? {
              pt: 60,
              position: 'fixed',
              top: 0,
              left: 0,
              bottom: 0,
              zIndex: 1,
            }
          : {}),
        width: showHistory ? 280 : 0,
        borderRight: showHistory
          ? tokens.theme.border.structural.neutralSubtle
          : 'none',
        backgroundColor: tokens.theme.bg.structural.surfaceSubtle,
        flexShrink: 0,
        overflow: 'hidden',
        transition: 'width 0.3s ease-in-out',
      })}
    >
      <Box sx={{ flex: 1, overflow: 'auto', minWidth: 280, pt: 16 }}>
        <ChatHistoryList
          history={history}
          onSelectChat={onSelectChat}
          onDeleteChat={onDeleteChat}
          onNewChat={onNewChat}
          currentChatId={currentChatId}
        />
      </Box>
    </Stack>
  );
};
